
  var _styles = {
  "componentContainer": {
    "width": "100%"
  },
  "vapContainer": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "vapImageFilter": {
    "position": "absolute"
  }
};



  module.exports = _styles;
  